@if (showLoadingScreen()) {
  <app-loading-screen></app-loading-screen>
} @else {
  <app-form-header [hideStepper]="showTutorial"></app-form-header>
  <main class="flex column vcenter">
    <div class="temp-boxes">
      @if (!showTutorial && step === "debtor") {
        <button
          class="back-to-tutorial"
          (click)="openTutorial()"
        >
          @if (!cameFromFeatures) {
            <mat-icon class="back-icon">arrow_back</mat-icon>
          }
          <span>{{ "CASE_FORM.TUTORIAL.BACK" | translate }}</span>
        </button>
      }
      <payee-autosave
        class="saved-text"
        data-testid="case-form-saved"
        [class.show]="justSaved"
      ></payee-autosave>
    </div>
    @if (loading() && canShowSpinner()) {
      <mat-progress-spinner
        diameter="100"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
    @if (showTutorial) {
      <app-case-form-tutorial></app-case-form-tutorial>
    } @else {
      <div id="form-components">
        @for (component of formComponents; track component.name) {
          @if (!!form.get(component.name)) {
            <ng-container [ngComponentOutlet]="component.component"></ng-container>
          }
        }
        @if (showNextPageButton) {
          <button
            mat-flat-button
            color="accent"
            class="next-page-button"
            data-testid="case-form-next"
            [disabled]="!canGoNextPage"
            (click)="nextPage()"
          >
            @if (!saving()) {
              <span class="next-page-glow"></span>
              <span class="next-page-text">
                {{ "CASE_FORM.GLOBAL.NEXT" | translate }}
              </span>
            } @else {
              <mat-progress-spinner
                color="accent"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            }
          </button>
        }
      </div>
    }
  </main>
  <footer>
    <app-footer></app-footer>
  </footer>
}
